import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { IValuationCity, IValuationMarker } from '@core/models';
import { City, Geomarker } from '@core/services';
import { TranslateModule } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-valoration-detail-comment',
  imports: [ReactiveFormsModule, TranslateModule],
  templateUrl: './valoration-detail-comment.html',
  styleUrl: './valoration-detail-comment.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValorationDetailComment {
  private readonly cityService = inject(City);
  private readonly markerService = inject(Geomarker);

  /** Variable que recibe desde un componente padre el identificador de la ciudad*/
  readonly city = input<number>(0);
  /** Variable que recibe desde un componente padre el identificador del usuario*/
  readonly user = input<number>(0);
  /** Variable que recibe desde un componente padre el identificador del geomarcador*/
  readonly marker = input<number>(0);
  /** Variable que guarda el estado de autenticación del usuario*/
  readonly authenticated = input<boolean>(false);
  /** Variable que permite emitir el comentario a un componente padre.*/
  // tslint:disable-next-line:no-output-rename
  readonly commentDone = output<any>();
  /** Variable que permite emitir el evento para abrir el formulario de autenticación en un componente padre.*/
  readonly openAuthFormChange = output<void>();
  /** Variable que guardará la valoración*/
  protected readonly commentControl = signal<FormControl>(new FormControl('', Validators.required));

  /**@ignore */
  constructor() {}

  /**
   * Función asincrona que agrega el comentario ya sea para una ciudad o geomarcadar, para esto hace uso de los identificadores
   * de usuario, ciudad, geomarcador y de la función addValuation() que se encuentra en los servicios tanto de ciudad
   * como de geomarcador, por ultimo emite la respuesta del mismo.
   */
  protected async comment(): Promise<void> {
    if (!this.authenticated()) {
      this.openAuthFormChange.emit();
      return;
    }

    if (this.commentControl().valid) {
      let commendResponse: any;
      if (this.city()) {
        const commentData = {
          city: this.city(),
          user: this.user(),
          detail: this.commentControl().value,
        };

        try {
          const response = await lastValueFrom(
            this.cityService.addValuation(commentData as IValuationCity),
          );
          commendResponse = response;
        } catch (error) {
          console.error('Error adding city valoration comment:', error);
          return;
        }
      } else if (this.marker()) {
        const commentData = {
          marker: this.marker(),
          user: this.user(),
          detail: this.commentControl().value,
        };

        try {
          const response = await lastValueFrom(
            this.markerService.addValuation(commentData as IValuationMarker),
          );
          commendResponse = response;
        } catch (error) {
          console.log('Error adding marker valoration comment:', error);
          return;
        }
      }
      this.commentControl().reset();
      this.commentDone.emit(commendResponse);
    }
  }
}
